import clsx from 'clsx';
import type { ReactNode } from 'react';

type MailListRowProps = {
  status?: ReactNode;
  subject: string;
  snippet: string;
  author: string;
  date: ReactNode;
  highlighted?: boolean;
  onClick: () => void;
};

export default function MailListRow({
  status,
  subject,
  snippet,
  author,
  date,
  highlighted = false,
  onClick,
}: MailListRowProps) {
  return (
    <li
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onClick();
        }
      }}
      className={clsx(
        'flex h-12 cursor-pointer items-center gap-md border-b border-solid border-border px-lg py-xs outline-hidden focus-visible:bg-gray',
        highlighted ? 'bg-primary_lighten' : 'bg-white hover:bg-gray'
      )}
    >
      <div className="flex min-w-0 flex-1 items-center gap-xs overflow-hidden whitespace-nowrap">
        {status}
        <span className="max-w-[60%] shrink-0 truncate text-body-sm text-main">{subject}</span>
        <span className="min-w-0 flex-1 truncate text-body-xs text-sub">{snippet}</span>
      </div>
      <span className="w-20 shrink-0 truncate text-body-xs text-sub">{author}</span>
      <div className="flex min-w-24 shrink-0 items-center justify-end gap-xxs text-right text-body-sm whitespace-nowrap text-main">
        {date}
      </div>
    </li>
  );
}
